<template>
  <Navbar></Navbar>
  <!-- 后端注入的实时详情 HTML 优先展示（Ctrl+U 可见）；
       iframe 通栏铺满，左右留白由注入页内部按官网同款内边距自带，保证 rem 基准与官网一致 -->
  <iframe v-if="detailHtmlContent" :srcdoc="detailHtmlContent" frameborder="0"
    style="display: block; width: 100%; height: auto; min-height: 600px; border: 0;" @load="autoResizeIframe">
  </iframe>
  <div class="new-detail-page" v-else>
    <div class="new-t1">
      {{ newsDetail.newsTitle }}
    </div>
    <div class="new-detail-time">
      {{ newsDetail.releaseDate }}
    </div>
    <div class="new-detail-t2" v-html="newsDetail.infoImgUrl">
    </div>
  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import { getNewsDetail } from '@/utils/common.js'

const newsId = new URLSearchParams(window.location.search).get('newsId') ? new URLSearchParams(window.location.search).get('newsId') : '36';
const newsDetail = ref({});

// 承载要显示的详情 HTML 字符串（来自后端注入的 script 标签；没有则保持原 Vue 渲染）
const detailHtmlContent = ref('')


const removeImgIpPrefix = (htmlStr) => {
  return htmlStr
    .replace(/http:\/\/180\.184\.29\.211:91/g, '')
    .replace(/http:\/\/180\.184\.29\.211:8991/g, '');
};
// iframe 高度持续跟随内容（图片加载、尺寸变化都同步，避免内部滚动条）
const autoResizeIframe = (e) => {
  const iframe = e.target;
  const resize = () => {
    try {
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      if (doc && doc.body) {
        const h = doc.body.scrollHeight + 'px';
        // 高度没变就不写，避免反复触发布局抖动
        if (iframe.style.height !== h) {
          iframe.style.height = h;
        }
      }
    } catch (err) {
      // 跨域时忽略
    }
  };
  // ResizeObserver 回调里同步改布局会被浏览器判为死循环并报
  // "ResizeObserver loop completed with undelivered notifications"（dev overlay 会全屏弹出），
  // 推迟到下一帧执行打断同步循环
  let pending = false;
  const scheduleResize = () => {
    if (pending) return;
    pending = true;
    iframe.contentWindow.requestAnimationFrame(() => {
      pending = false;
      resize();
    });
  };
  resize();
  try {
    const win = iframe.contentWindow;
    const doc = win.document;
    // 正文里的链接统一顶层窗口打开，避免在 iframe 内部导航
    doc.querySelectorAll('a').forEach((a) => {
      const m = (a.getAttribute('href') || '').match(/\/portal\/news\/view\/(\d+)/);
      if (m) {
        a.setAttribute('href', '/news-detail.html?newsId=' + m[1]);
      }
      a.setAttribute('target', '_top');
    });

    // ========== 新增：处理video、source地址 ==========
    const replaceVideoSrc = (el) => {
      const src = el.getAttribute('src');
      if (!src) return;
      const newSrc = src
        .replace(/http:\/\/180\.184\.29\.211:91/g, '')
        .replace(/http:\/\/180\.184\.29\.211:8991/g, '');
      if (newSrc !== src) {
        el.setAttribute('src', newSrc);
      }
    };
    doc.querySelectorAll('video, source').forEach(v => {
      replaceVideoSrc(v);
    });
    // ===============================================

    win.addEventListener('load', resize);
    doc.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', resize);
        img.addEventListener('error', resize);
      }
    });
    if (win.ResizeObserver) {
      new win.ResizeObserver(scheduleResize).observe(doc.body);
    }
  } catch (err) {
    // 跨域时忽略
  }

};

// 从后端注入的 <script type="text/html" id="news-detail-template"> 中读取实时 HTML
const loadDetailHtmlFromDom = () => {
  const tpl = document.getElementById('news-detail-template');
  if (tpl && tpl.textContent && tpl.textContent.trim()) {
    // 后端注入时把闭合 script 标签转义成了 <\/script>，这里还原后再交给 iframe
    const html = tpl.textContent.replace(/<\\\/script>/g, '</' + 'script>');
    detailHtmlContent.value = removeImgIpPrefix(html);
    // 标题栏同步为新闻标题
    const m = html.match(/<title>([\s\S]*?)<\/title>/);
    if (m && m[1]) {
      document.title = m[1];
    }
    return true;
  }
  return false;
};

const getNewsDetails = async () => {
  try {
    const detail = await getNewsDetail(newsId);
    detail.data.infoImgUrl = detail.data.infoImgUrl.replace(/http:\/\/180\.184\.29\.211:91/g, '');
    newsDetail.value = detail.data;
    document.title = detail.data.newsTitle;

  } catch (error) {
    console.log(error)
  }
}
onMounted(() => {
  // 先用后端注入的实时 HTML；没有再走原 AJAX 渲染
  if (!loadDetailHtmlFromDom()) {
    getNewsDetails();
  }
})

</script>

<script>
export const pageConfig = {
  title: '新闻详情',
  keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
  description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
  outputPath: 'news-detail.html'
};

import { createApp } from 'vue';
import App from './news-detail.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}


// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./news-detail.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss">
.new-detail-page {
  padding: 1.48rem 4rem;
  width: calc(100% - 8rem);

  .new-t1 {
    font-size: 0.34rem;
    color: #000000;
    font-weight: 500;
    margin-bottom: 0.53rem;
  }

  .new-detail-time {
    font-weight: 400;
    font-size: 0.18rem;
    color: #666B6B;
    margin-bottom: 0.4rem;
    padding-bottom: 0.23rem;
    border-bottom: 0.01rem solid rgba($color: #000000, $alpha: 0.24);

  }

  .new-detail-t2 {
    font-size: 0.18rem;
    color: #404040;
    font-weight: 400;
    margin-bottom: 0.4rem;
    text-indent: 0.32rem;

    p {
      // display: block;
      margin: 0;
      margin-bottom: 0.4rem;
    }

    img {
      padding: 0 2.26rem;
      width: calc(100% - 4.52rem);
      margin-top: 0.4rem;
    }

    iframe {
      display: block;
      margin: 0;
      width: 100%;
      height: 80vh;
      object-fit: cover;
    }

    video {
      display: block;
      margin: 0;
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }
}

@media (max-width: 768px) {
  .new-detail-page {
    padding: 1.48rem 0.45rem;
    width: calc(100% - 0.9rem);

    .new-detail-t2 {
      font-size: 0.22rem;
      line-height: 0.4rem;

      img {
        padding: 0;
        width: 100%;
      }
    }
  }
}
</style>